import Vue from 'vue';

import MenuAPI from '@/api/menu';

export default {
  namespaced: true,
  state: {
    menus: [],

    is_editing: false,

    current: null,

    product: null,

    exclusives_category: false,

    lastSave: null,

    is_currently_saving: false,
    is_product_updating: false,
    requested_full_update: false,
    editor_out_of_sync: false,

    current_locale: null,

    ui_translation_preview: true,

    highlight_errors: false,
  },
  mutations: {
    //
    //General mutations
    //
    setMenus(state, payload) {
      state.menus = payload;
    },
    setCurrentMenu(state, payload) {
      state.current = payload;
    },
    toggleHighlightErrors(state) {
      state.highlight_errors = !state.highlight_errors;
    },
    setOutOfSync(state, value) {
      state.editor_out_of_sync = value;
    },
    updateLastSave(state) {
      state.lastSave = new Date();
    },
    setProductUpdating(state, value) {
      state.is_product_updating = value;
    },
    setRequestedFullUpdate(state, value) {
      state.requested_full_update = value;
    },
    setCurrentlySaving(state, payload) {
      state.is_currently_saving = payload;
    },
    setUiTranslationPreview(state, value) {
      state.ui_translation_preview = value;
    },
    setCurrentLocale(state, payload) {
      state.current_locale = payload;

      if (payload) {
        for (const product of state.current.products) {
          if (!product.i18n) {
            Vue.set(product, 'i18n', []);
          }

          const fitting_i18n = product.i18n.find((it) => it.locale == payload);

          if (fitting_i18n) continue;

          let price_groups_i18n_empty = product.price_groups.map((group) => {
            return {
              name: null,
              items: group.items.map((i) => null),
            };
          });

          product.i18n.push({
            locale: payload,
            name: null,
            description: null,
            price_groups: price_groups_i18n_empty,
          });
        }
      }
    },
    setEditing(state, payload) {
      state.is_editing = payload;
    },
    setMenuTag(state, payload) {
      state.menus.forEach((menu, index) => {
        if (menu._id == payload.menu_id) {
          Vue.set(state.menus[index], 'tag', payload.tag);
        }
      });
    },
    setMenuDiscount(state, payload) {
      state.menus.forEach((menu, index) => {
        if (menu._id == payload.menu_id) {
          Vue.set(state.menus[index], 'discount', payload.discount);
        }
      });
    },
    setMenuTitle(state, payload) {
      state.menus.forEach((m, i) => {
        if (m._id == payload.menu_id) {
          Vue.set(state.menus[i], 'title', payload.title);
        }
      });
    },
    //
    //Current menu specific mutations
    //
    addCategory(state, payload) {
      let i18n = {};

      state.current.locales.forEach((l) => (i18n[l] = null));

      state.current.categories.push({
        name: payload,
        i18n,
      });
    },
    addCategoryRaw(state, payload) {
      state.current.categories.push(payload);
    },
    addExclusivesCategory(state) {
      state.current.categories.unshift({
        name: 'exclusives',
      });
    },
    changeExclusivesCategory(state, payload) {
      state.exclusives_category = payload;
    },
    editCategory(state, payload) {
      const old_name = state.current.categories[payload.index].name;

      //Don't forget to change products category from old to new!
      state.current.products.forEach((product, index) => {
        if (product.category == old_name) {
          Vue.set(state.current.products[index], 'category', payload.name);
        }
      });

      Vue.set(state.current.categories[payload.index], 'name', payload.name);
    },
    removeCategory(state, payload) {
      const category = state.current.categories[payload.index];
      const filtered = state.current.products.filter(
        (p) => p.category_id != category._id
      );
      Vue.set(state.current, 'products', filtered);
      Vue.delete(state.current.categories, payload.index);
    },
    removeCategoryById(state, category_id) {
      const index = state.current.categories.findIndex(
        (c) => c._id == category_id
      );
      const filtered = state.current.products.filter(
        (p) => p.category_id != category_id
      );
      Vue.set(state.current, 'products', filtered);
      Vue.delete(state.current.categories, index);
    },
    setCategories(state, payload) {
      Vue.set(state.current, 'categories', payload);
    },
    setProductImage(state, payload) {
      state.current.products.forEach((product, index) => {
        if (payload.id == product._id) {
          Vue.set(state.current.products[index], 'image', payload.url);
        }
      });
    },
    addProduct(state, payload) {
      state.current.products.push(payload);
    },
    chooseProduct(state, product) {
      state.product = product;
    },
    chooseProductById(state, id) {
      const product = state.current.products.find((pr) => pr._id === id);
      if (product) state.product = product;
    },
    toggleExclusive(state, dish) {
      const old_value = !!state.product.is_exclusive;

      Vue.set(state.product, 'is_exclusive', !old_value);
    },
    removeProduct(state, dish) {
      // const first_index = state.current.products.findIndex((p) => {
      //     return p._id == dish._id &&
      //      p.name == dish.name &&
      //      dish.category == p.category &&
      //      p.prices.length == dish.prices.length &&
      //      p.description == dish.description
      // });
      const first_index = state.current.products.findIndex((p) => {
        //we can use object comparison, because their references are equal!
        return p == dish;
      });

      if (first_index === -1) return;

      Vue.delete(state.current.products, first_index);
    },
    removeProductById(state, id) {
      const first_index = state.current.products.findIndex((p) => {
        return p._id === id;
      });

      if (first_index === -1) return;

      Vue.delete(state.current.products, first_index);
    },
    setProductData(state, payload) {
      if (state.product) Vue.set(state.product, payload.key, payload.value);
    },
    setProductImageByProduct(state, payload) {
      const first_index = state.current.products.findIndex(
        (p) => p == payload.product
      );

      if (first_index != -1) {
        let key = payload.thumbnail ? 'image_thumbnail' : 'image';
        if (payload.original) key = 'image_original';

        Vue.set(state.current.products[first_index], key, payload.url);
      }
    },
    addVariant(state, payload) {
      // state.current.products.forEach((product, index) => {
      //     if (product._id != payload.id) return;

      //     state.current.products[index].prices.push({
      //         variant: payload.variant,
      //         value: payload.value
      //     });
      // });
      state.product.price_groups[0].items.push({
        name: payload.name,
        price: payload.price,
        weight: payload.weight,
      });
    },
    addModificator(state, payload) {
      // state.current.products.forEach((product, index) => {
      //     if (product._id != payload.id) return;

      //     state.current.products[index].modificators.push({
      //         name: payload.name,
      //         price: payload.price
      //     });
      // });
      state.product.price_groups[1].items.push({
        name: payload.name,
        price: payload.price,
        weight: payload.weight,
      });
    },
    removeVariant(state, payload) {
      // state.current.products.forEach((product, index) => {
      //     if (product._id != payload.id) return;

      //     state.current.products[index].prices.splice(payload.index, 1);
      // });
      state.product.prices.splice(payload.index, 1);
    },
    // removePriceGroupItem(state, payload) {
    //     state.product.price_groups[payload.group_index].items.splice(payload.item_index, 1);
    // },
    removeModificator(state, payload) {
      // state.current.products.forEach((product, index) => {
      //     if (product._id != payload.id) return;

      //     console.log(payload.index);

      //     Vue.delete(state.current.products[index].modificators, payload.index);

      //     // state.current.products[index].modificators.splice(payload.index, 1);
      // });
      state.product.modificators.splice(payload.index, 1);
    },
    setOriginalLocale(state, locale) {
      Vue.set(state.current, 'original_locale', locale);
    },
    rearrangeDishes(state, payload) {
      const pi1 = state.current.products.findIndex(
        (p) => p._id == payload.first
      );
      const pi2 = state.current.products.findIndex(
        (p) => p._id == payload.second
      );

      const temp = state.current.products[pi1];

      Vue.delete(state.current.products, pi1);

      state.current.products.splice(pi2, 0, temp);

      // Vue.set(state.current.products, pi1, state.current.products[pi2]);
      // Vue.set(state.current.products, pi2, temp);
    },
    updateModificator(state, payload) {
      const from = payload.from;
      const to = payload.to;

      state.current.products.forEach((product, product_index) => {
        if (product.modificators) {
          product.modificators.forEach((mod, mod_index) => {
            if (mod.name == from.name) {
              Vue.set(
                state.current.products[product_index].modificators[mod_index],
                'name',
                to.name
              );
              Vue.set(
                state.current.products[product_index].modificators[mod_index],
                'price',
                to.price
              );
              if (to.poster_product_id)
                Vue.set(
                  state.current.products[product_index].modificators[mod_index],
                  'poster_product_id',
                  to.poster_product_id
                );
            }
          });
        }
      });
    },
    removeGlobalModificator(state, payload) {
      const name = payload.name;
      const price = payload.price;

      state.current.products.forEach((product, product_index) => {
        state.current.products[
          product_index
        ].modificators = product.modificators.filter((m) => {
          return m.name != name && m.price != price;
        });
      });
    },
    setMenuUpdatedAt(state, payload) {
      state.menus.forEach((menu, index) => {
        if (payload.id == menu._id) {
          if (state.menus[index].updated_at) {
            const new_update_date = new Date(payload.updated_at);
            const old_update_date = new Date(state.menus[index].updated_at);

            if (new_update_date < old_update_date) return;
          }

          Vue.set(state.menus[index], 'updated_at', payload.updated_at);
          // console.log(`set menu # ${index} to ${payload.updated_at}`);
        }
      });

      if (state.current._id == payload.id) {
        Vue.set(state.current, 'updated_at', payload.updated_at);
      }
    },
    addPriceGroup(state, payload) {
      const to_add = !!payload
        ? payload
        : {
            name: null,
            single_select: true,
            items: [
              {
                name: null,
                price: null,
                weight: null,
                stock: true,
              },
            ],
          };

      state.product.price_groups.push(to_add);

      state.product.i18n.forEach((item, index) => {
        state.product.i18n[index].price_groups.push({
          name: null,
          items: [null],
        });
      });
    },
    addPriceGroupItem(state, payload) {
      state.product.price_groups[payload.index].items.push(
        payload.price_group_item || {
          name: null,
          price: null,
          weight: null,
          stock: true,
        }
      );

      state.product.i18n.forEach((item, index) => {
        if (!state.product.i18n[index].price_groups[payload.index].items) {
          Vue.set(state.product.i18n[payload.index].price_groups, 'items', []);
        }
        state.product.i18n[index].price_groups[payload.index].items.push(null);
      });
    },
    removePriceGroupItem(state, payload) {
      state.product.price_groups[payload.group_index].items.splice(
        payload.item_index,
        1
      );

      state.product.i18n.forEach((item, index) => {
        state.product.i18n[index].price_groups[
          payload.group_index
        ].items.splice(payload.item_index, 1);
      });

      Vue.set(state.product, 'force_modified_at', new Date());
    },
    removePriceGroup(state, payload) {
      state.product.price_groups.splice(payload.index, 1);

      state.product.i18n.forEach((item, index) => {
        state.product.i18n[index].price_groups.splice(payload.index, 1);
      });

      console.log(`menu/removePriceGroup: commit for {${payload.index}}`);

      Vue.set(state.product, 'force_modified_at', new Date());
    },
    setPriceGroupItemData(state, payload) {
      Vue.set(
        state.product.price_groups[payload.group_index].items[
          payload.item_index
        ],
        payload.key,
        payload.value
      );
    },
    setPriceGroupData(state, payload) {
      const group_index = state.product.price_groups.findIndex(
        (g) => g._id == payload.id
      );

      if (group_index == -1) return;

      Vue.set(
        state.product.price_groups[group_index],
        payload.key,
        payload.value
      );
    },
    setMenuSchedule(state, payload) {
      Vue.set(state.current, 'schedule', payload);
    },
    setMenuTax(state, payload) {
      Vue.set(state.current, 'tax_id', payload);
    },
    forceModifyCategoryProducts(state, payload) {
      state.current.products.forEach((product, index) => {
        if (product.category_id == payload) {
          Vue.set(
            state.current.products[index],
            'force_modified_at',
            new Date()
          );
        }
      });
    },
    makeProductForceModified(state) {
      Vue.set(state.product, 'force_modified_at', new Date());
    },
    /* 
            Menu localiztion
        */
    addLocale(state, locale) {
      state.current.locales.push(locale);

      Vue.set(state.current.tag_i18n, locale, null);

      state.current.categories.forEach((cat, index) => {
        if (!cat.i18n) {
          Vue.set(state.current.categories[index], 'i18n', {});
        }

        Vue.set(state.current.categories[index].i18n, locale, null);
      });

      state.current.products.forEach((product, index) => {
        if (!product.i18n) {
          Vue.set(state.current.products[index], 'i18n', []);
        }

        let price_groups_i18n_empty = product.price_groups.map((group) => {
          return {
            name: null,
            items: group.items.map((i) => null),
          };
        });

        state.current.products[index].i18n.push({
          locale,
          name: null,
          description: null,
          price_groups: price_groups_i18n_empty,
        });
      });
    },
    setLocaleProductName(state, payload) {
      Vue.set(state.product.i18n[payload.locale_index], 'name', payload.value);
    },
    setLocaleProductDescription(state, payload) {
      Vue.set(
        state.product.i18n[payload.locale_index],
        'description',
        payload.value
      );
    },
    removeLocale(state, payload) {
      Vue.set(
        state.current,
        'locales',
        state.current.locales.filter((l) => l != payload)
      );

      state.current.categories.forEach((cat, index) => {
        if (cat.i18n) {
          Vue.delete(state.current.categories[index].i18n, payload);
        }
      });

      state.current.products.forEach((product, index) => {
        if (product.i18n) {
          const filtered = product.i18n.filter((o) => o.locale != payload);

          Vue.set(state.current.products[index], 'i18n', filtered);
        }
      });

      Vue.delete(state.current.tag_i18n, payload);
    },
    setTagLocaliztion(state, payload) {
      Vue.set(state.current, 'tag_i18n', payload);
    },
    rearrangePriceGroup(state, payload) {
      const pg1 = state.product.price_groups[payload.old_index];
      const pg2 = state.product.price_groups[payload.new_index];

      const temp = pg1;

      Vue.set(state.product.price_groups, payload.old_index, pg2);
      Vue.set(state.product.price_groups, payload.new_index, temp);

      state.product.i18n.forEach((i18n) => {
        if (!i18n.price_groups[payload.old_index]) return;

        const tmp1 = i18n.price_groups[payload.old_index];

        i18n.price_groups[payload.old_index] =
          i18n.price_groups[payload.new_index];
        i18n.price_groups[payload.new_index] = tmp1;
      });
    },
    rearrangeMenus(state, payload) {
      const m1 = state.menus[payload.first];
      const m2 = state.menus[payload.second];

      let group_id_1 = m1.group_id || 0;
      let group_id_2 = m2.group_id || 0;

      console.log(group_id_1, group_id_2);

      // if (group_id_1 == group_id_2) {
      //     group_id_1++;
      // }

      Vue.set(state.menus[payload.first], 'group_id', group_id_2);
      Vue.set(state.menus[payload.second], 'group_id', group_id_1);

      state.menus.sort((a, b) => {
        const ga = a.group_id || 0;
        const gb = b.group_id || 0;

        return ga - gb;
      });
    },
    resetMenusSorting(state, payload) {
      state.menus.forEach((menu, index) => {
        Vue.set(state.menus[index], 'group_id', index + 1);
      });
    },
    toggleProductMode(state, payload) {
      Vue.set(
        state.product.enabled_modes,
        payload.mode,
        !state.product.enabled_modes[payload.mode]
      );

      Vue.set(state.product.modes_changed_at, payload.mode, new Date());
    },
    transferProduct(state, payload) {
      const target_menu_id = payload.menu_id;
      const target_category = payload.category;

      const menu_idx = state.menus.findIndex((m) => m._id == target_menu_id);

      if (menu_idx === -1) return;

      if (state.current._id == target_menu_id) {
        Vue.set(state.product, 'category', target_category.name);
        Vue.set(state.product, 'category_id', target_category._id);
        Vue.set(state.product, 'force_modified_at', new Date());
        return;
      }

      const product_index = state.current.products.indexOf(state.product);

      Vue.set(state.product, 'category', target_category.name);
      Vue.set(state.product, 'category_id', target_category._id);
      Vue.set(state.product, 'force_modified_at', new Date());

      state.menus[menu_idx].products.push(state.product);

      state.current.products.splice(product_index, 1);
    },
    setMenuContentType(state, payload) {
      state.menus.forEach((menu, index) => {
        if (menu._id == payload.menu_id) {
          Vue.set(state.menus[index], 'content_type', payload.value);
        }
      });

      Vue.set(state.current, 'content_type', payload.value);
    },
    setMenuShowExclusives(state, payload) {
      state.menus.forEach((menu, index) => {
        if (menu._id == payload.menu_id) {
          Vue.set(state.menus[index], 'show_exclusives', payload.value);
        }
      });

      Vue.set(state.current, 'show_exclusives', payload.value);
    },
    enableModeForAllProducts(state, payload) {
      state.current.products.forEach((p, i) => {
        if (!state.current.products[i].modes_changed_at[payload.mode])
          Vue.set(state.current.products[i].enabled_modes, payload.mode, true);
      });
    },
    setMenuPayReceiverId(state, payload) {
      state.menus.forEach((menu, index) => {
        if (menu._id == payload.menu_id) {
          Vue.set(state.menus[index], 'pay_receiver_id', payload.value);
        }
      });

      Vue.set(state.current, 'pay_receiver_id', payload.value);
    },
    changeUnitForAllProducts(state, payload) {
      state.current.products.forEach((p, i) => {
        if (!state.current.products[i].unit_changed_at)
          Vue.set(state.current.products[i], 'unit', payload);
      });
    },
    rearrangePriceGroupItem(state, { group_index, item_index, delta }) {
      const new_index = item_index + delta;

      const item = state.product.price_groups[group_index].items[item_index];

      state.product.price_groups[group_index].items.splice(item_index, 1);
      state.product.price_groups[group_index].items.splice(new_index, 0, item);

      for (const locale of state.product.i18n) {
        if (locale.price_groups[group_index]) {
          if (locale.price_groups[group_index].items[item_index]) {
            const tmp = locale.price_groups[group_index].items[item_index];

            locale.price_groups[group_index].items[item_index] =
              locale.price_groups[group_index].items[new_index];
            locale.price_groups[group_index].items[new_index] = tmp;
          }
        }
      }
    },
    deleteLocale(state, locale) {
      state.current.products.forEach((product) => {
        const localeIndex = product.i18n.find((it) => it.locale == locale);

        if (localeIndex !== -1) {
          product.i18n.splice(localeIndex, 1);
        }
      });

      Vue.set(
        state.current,
        'locales',
        state.current.locales.filter((l) => l != locale)
      );
    },
    postFixModificatorsLocalizations(state) {
      state.product.i18n.forEach((localeObject) => {
        if (!localeObject.price_groups) {
          localeObject.price_groups = [];
        }

        console.log(`[MenuModule] Post-fixing locale ${localeObject.locale}`);

        for (
          let i = localeObject.price_groups.length;
          i < state.product.price_groups.length;
          i++
        ) {
          console.log(
            `[MenuModule] Post price-group ${i} => ${localeObject.price_groups[i]}`
          );

          if (localeObject.price_groups[i]) continue;

          Vue.set(localeObject.price_groups, i, {
            name: null,
            items: state.product.price_groups[i].items.map((item) => null),
          });

          console.log(
            `[MenuModule] Applied post-fix for locale ${localeObject.locale} for price group #${i} (${state.product.price_groups[i].name})`
          );
        }
      });
    },
  },
  actions: {
    fetchMenus(context) {
      return new Promise((resolve, reject) => {
        const fetch_params = {};

        if (context.rootState.selected_chain) {
          fetch_params.chain_id = context.rootState.selected_chain._id;
        } else {
          fetch_params.cafe_id = context.rootState.cafe._id;
        }

        MenuAPI.getList(
          fetch_params.cafe_id || undefined,
          fetch_params.chain_id || undefined
        )
          .then((data) => {
            context.commit('setMenus', data.list);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    create(context, title) {
      return new Promise((resolve, reject) => {
        const create_params = {
          title,
        };

        if (context.rootState.selected_chain) {
          create_params.chain_id = context.rootState.selected_chain._id;
        } else {
          create_params.cafe_id = context.rootState.cafe._id;
        }

        MenuAPI.create(create_params)
          .then((data) => {
            context
              .dispatch('fetchMenus')
              .then(resolve)
              .catch(reject);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    remove(context, menu_id) {
      return new Promise((resolve, reject) => {
        MenuAPI.remove(menu_id)
          .then((data) => {
            context.dispatch('fetchMenus');
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    duplicate(context, payload) {
      return new Promise((resolve, reject) => {
        MenuAPI.clone(payload.menu_id, payload.title)
          .then((data) => {
            context.dispatch('fetchMenus');
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    save(context, payload) {
      if (context.state.is_currently_saving) return;

      const saving_id = context.state.current._id;

      return new Promise((resolve, reject) => {
        if (context.state.is_product_updating) {
          context.commit('setRequestedFullUpdate', true);
          resolve();
          return;
        }

        context.commit('setCurrentlySaving', true);
        MenuAPI.update(saving_id, context.state.current)
          .then((data) => {
            context.commit('updateLastSave');
            context.commit('setMenuUpdatedAt', {
              id: saving_id,
              updated_at: data.updated_at,
            });
            console.log(`Menu saved ${saving_id}.`);
            context.commit('setCurrentlySaving', false);
            resolve();
          })
          .catch((error) => {
            context.commit('setCurrentlySaving', false);
            if (error == 'expired') {
              // context.dispatch('showError', 'menu_sync', {
              //     root: true
              // });
              context.commit('setOutOfSync', true);

              // if (context.state.is_editing) {
              //     setTimeout(() => {
              //         if (window.location.href.includes('sync_menu_id')) {
              //             window.location.href = window.location.origin + `/menus?sync_menu_id=${context.state.current._id}`;
              //         } else {
              //             window.location.href = window.location.href + `?sync_menu_id=${context.state.current._id}`;
              //         }

              //     }, 3000);
              // } else {
              //     setTimeout(() => {
              //         window.location.reload();
              //     }, 3000);
              // }
            } else {
              context.dispatch('showError', 'menu_save', {
                root: true,
              });
            }

            reject(error);
          });
      });
    },
    checkDefferedMenuUpdate(context, menu_id) {
      if (context.state.requested_full_update) {
        context.commit('setRequestedFullUpdate', false);

        if (!menu_id) {
          context.dispatch('save');
        } else {
          context.dispatch('updateMenu', {
            id: menu_id,
          });
        }
      }
    },
    updateMenu(context, payload) {
      return new Promise((resolve, reject) => {
        const menu = context.state.menus.find((m) => m._id == payload.id);

        if (!menu) {
          resolve();
          return;
        }

        MenuAPI.update(payload.id, menu)
          .then((data) => {
            context.commit('updateLastSave');
            context.commit('setMenuUpdatedAt', {
              id: payload.id,
              updated_at: data.updated_at,
            });
            console.log(`Menu updated ${payload.id}.`);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createEmptyProduct(context, payload) {
      const product = {
        name: '',
        ingridients: '',
        description: '',
        image: '',
        preset: 'dish',
        base_price: null,
        base_weight: null,
        prices: [],
        price_groups: [
          // {
          //     name: null,
          //     single_select: true,
          //     items: [{
          //         name: null,
          //         weight: null,
          //         price: null
          //     }]
          // },
          // {
          //     name: null,
          //     single_select: false,
          //     items: []
          // }
        ],
        modificators: [],
        category: payload.category.name,
        category_id: payload.category._id,
        stock: true,
        tax_id: 'parent',
        i18n: context.state.current.locales.map((l) => {
          return {
            locale: l,
            name: null,
            description: null,
            price_groups: [],
          };
        }),
        unit: context.state.current.content_type == 'drinks' ? 'l' : 'g',
        weighted: false,
        weight_flag: 0,
        is_excise: false,
        ingredients: [],
        packaging_costs: [],
        enabled_modes: {
          inside: false,
          preorder: false,
          delivery: false,
        },
      };

      const menu_id = context.state.current._id;

      if (context.rootState.cafe.menu_ids.includes(menu_id)) {
        product.enabled_modes.inside = true;
      }

      if (context.rootState.cafe.preorder.menu_ids.includes(menu_id)) {
        product.enabled_modes.preorder = true;
      }

      if (context.rootState.cafe.delivery.menu_ids.includes(menu_id)) {
        product.enabled_modes.delivery = true;
      }

      return context.dispatch('addProduct', product);
    },
    addProduct(context, product) {
      return new Promise((resolve, reject) => {
        context.commit('setProductUpdating', true);

        MenuAPI.addProduct(context.state.current._id, product)
          .then((data) => {
            context.commit('setProductUpdating', false);
            context.commit('addProduct', data.product);
            if (data.category) {
              context.commit('addCategoryRaw', data.category);
            }
            context.commit('updateLastSave');
            context.commit('setMenuUpdatedAt', {
              id: context.state.current._id,
              updated_at: data.updated_at,
            });
            context.commit(
              'chooseProduct',
              context.state.current.products[
                context.state.current.products.length - 1
              ]
            );
            context.dispatch('checkDefferedMenuUpdate');

            resolve();
          })
          .catch((error) => {
            context.dispatch('showError', 'menu_save', {
              root: true,
            });
            context.commit('setProductUpdating', false);
            reject(error);
          });
      });
    },
    addCategory(context, payload) {
      return new Promise((resolve, reject) => {
        MenuAPI.addCategory(context.state.current._id, payload)
          .then((data) => {
            context.commit('setMenuUpdatedAt', {
              id: context.state.current._id,
              updated_at: data.updated_at,
            });

            context.commit('setCategories', data.categories);

            context.dispatch('checkDefferedMenuUpdate');

            resolve();
          })
          .catch((error) => {
            context.dispatch('showError', 'menu_save', {
              root: true,
            });
            reject(error);
          });
      });
    },
    duplicateProduct(context, payload) {
      const copy = JSON.parse(JSON.stringify(context.state.product));

      delete copy._id;

      copy.name = `${context.state.product.name} ${payload.suffix}`;

      return context.dispatch('addProduct', copy);
    },
    updateProduct(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('setProductUpdating', true);

        MenuAPI.updateProduct(
          payload ? payload.menu_id : context.state.current._id,
          payload ? payload.product._id : context.state.product._id,
          payload ? payload.product : context.state.product
        )
          .then((data) => {
            context.commit('setMenuUpdatedAt', {
              id: context.state.current._id,
              updated_at: data.updated_at,
            });

            context.commit('setProductData', {
              key: 'updated_at',
              value: data.updated_at,
            });

            context.dispatch('checkDefferedMenuUpdate');

            resolve();
          })
          .catch((error) => {
            context.dispatch('showError', 'menu_save', {
              root: true,
            });
            reject(error);
          })
          .finally(() => {
            context.commit('setProductUpdating', false);
          });
      });
    },
    addPriceGroupToProduct(context, { product_id, price_group }) {
      const product = context.state.current.products.find(
        (pr) => pr._id == product_id
      );

      if (!product) return Promise.resolve();

      const existing_price_group = product.price_groups.find((pg) => {
        return (
          pg.name == price_group.name &&
          pg.items.length == price_group.items.length &&
          pg.single_select == pg.single_select
        );
      });

      if (existing_price_group) return;

      context.commit('chooseProduct', product);
      context.commit('addPriceGroup', price_group);

      return context.dispatch('updateProduct');
    },
    removePriceGroupFromProduct(
      context,
      { product_id, group_id, price_group_name }
    ) {
      const product = context.state.current.products.find(
        (pr) => pr._id == product_id
      );

      if (!product) return Promise.resolve();

      const group_index = product.price_groups.findIndex(
        (g) => g._id == group_id || (g.name && g.name == price_group_name)
      );

      if (group_index === -1) return Promise.resolve();

      context.commit('chooseProduct', product);
      context.commit('removePriceGroup', {
        index: group_index,
      });

      return context.dispatch('updateProduct');
    },
    addPriceGroupItemToProduct(
      context,
      { product_id, price_group_item, group_index }
    ) {
      const product = context.state.current.products.find(
        (pr) => pr._id == product_id
      );

      if (!product) return Promise.resolve();

      if (!product.price_groups[group_index]) return Promise.resolve();

      if (
        price_group_item.poster_modification_id ||
        price_group_item.poster_modificator_id
      ) {
        const existing = product.price_groups[group_index].items.find((it) => {
          if (price_group_item.poster_modificator_id) {
            return (
              it.poster_modificator_id == price_group_item.poster_modificator_id
            );
          }

          if (price_group_item.poster_modification_id) {
            return (
              it.poster_modification_id ==
              price_group_item.poster_modification_id
            );
          }

          return false;
        });

        if (existing) return Promise.resolve();
      }

      context.commit('chooseProduct', product);
      context.commit('addPriceGroupItem', {
        index: group_index,
        price_group_item,
      });

      return context.dispatch('updateProduct');
    },
    removeProduct(context, id) {
      return new Promise((resolve, reject) => {
        context.commit('setProductUpdating', true);

        const product_id = id || context.state.product._id;

        MenuAPI.removeProduct(context.state.current._id, product_id)
          .then((data) => {
            context.commit('setMenuUpdatedAt', {
              id: context.state.current._id,
              updated_at: data.updated_at,
            });

            context.commit('removeProductById', product_id);

            context.dispatch('checkDefferedMenuUpdate');

            resolve();
          })
          .catch((error) => {
            context.dispatch('showError', 'menu_save', {
              root: true,
            });
            reject(error);
          })
          .finally(() => {
            context.commit('setProductUpdating', false);
          });
      });
    },
    duplicateCategory(context, category_id) {
      return new Promise((resolve, reject) => {
        const menu_id = context.state.current._id;

        MenuAPI.duplicateCategory(menu_id, category_id)
          .then((data) => {
            context.commit('setMenuUpdatedAt', {
              id: menu_id,
              updated_at: data.updated_at,
            });

            context.commit('addCategoryRaw', data.created_category);

            for (const product of data.created_products) {
              context.commit('addProduct', product);
            }

            context.dispatch('checkDefferedMenuUpdate');

            resolve();
          })
          .catch((error) => {
            context.dispatch('showError', 'menu_save', {
              root: true,
            });
            reject(error);
          });
      });
    },
    moveCategory(context, { category_id, dst_menu_id }) {
      return new Promise((resolve, reject) => {
        const menu_id = context.state.current._id;

        MenuAPI.moveCategory(menu_id, category_id, dst_menu_id)
          .then((data) => {
            context.commit('setMenuUpdatedAt', {
              id: menu_id,
              updated_at: data.updated_at,
            });

            context.commit('setMenuUpdatedAt', {
              id: dst_menu_id,
              updated_at: data.updated_at,
            });

            context.commit('removeCategoryById', category_id);

            context.dispatch('checkDefferedMenuUpdate');

            resolve();
          })
          .catch((error) => {
            context.dispatch('showError', 'menu_save', {
              root: true,
            });
            reject(error);
          });
      });
    },
  },
  getters: {
    getById(state) {
      return (id) => {
        if (!id) return null;

        return state.menus.find((m) => m._id == id);
      };
    },
    findGlobalProduct(state, getters) {
      return (menu_id, product_id) => {
        const menu = getters.getById(menu_id);

        if (!menu) return null;

        return menu.products.find((p) => p._id == product_id);
      };
    },
    productsForCategory(state) {
      return (category) => {
        return state.current.products.filter(
          (p) => p.category_id == category._id
        );
      };
    },
    exclusivesList(state) {
      if (!state.current || !state.current.products) return [];
      return state.current.products.filter((item) => !!item.is_exclusive);
    },
    modificatorsList(state) {
      if (!state.current) return [];

      let modificators = [];

      state.current.products.forEach((product) => {
        if (product.modificators) {
          product.modificators.forEach((mod) => {
            const index = modificators.findIndex((i) => i.name == mod.name);

            if (index == -1) {
              let to_push = mod;
              to_push.image = product.image;

              modificators.push(to_push);
            }
          });
        }
      });

      return modificators;
    },
    allPriceGroups(state) {
      let groups = [];

      const unique_set = {};

      state.current.products.forEach((product) => {
        product.price_groups.forEach((group) => {
          const group_hash = `${group.name}:${
            group.single_select
          }:${group.items
            .map((i) => `${i.name}:${i.weight}:${i.price}`)
            .join(',')}`;

          if (unique_set[group_hash]) return;

          unique_set[group_hash] = true;

          groups.push({
            product_name: product.name,
            category: product.category,
            content: group,
          });
        });
      });

      return groups;
    },
    isProductValid(state) {
      // DEPRECATED, USE isDishValid
      if (
        !state.product.name ||
        !state.product.prices ||
        !state.product.prices.length
      )
        return false;

      return true;
    },
    menuModes(state, getters, rootState) {
      return (id) => {
        id = id || state.current._id;

        if (!rootState.owner || !rootState.cafe.modes) {
          return {
            inside: false,
            delivery: false,
            preorder: false,
            preview: false,
          };
        }

        let id_containers = {
          preorder: rootState.cafe.preorder.menu_ids,
          inside: rootState.cafe.menu_ids,
          delivery: rootState.cafe.delivery.menu_ids,
          hotels: rootState.cafe.hotels.menu_ids,
          preview: rootState.cafe.preview.menu_ids,
        };

        if (rootState.selected_chain) {
          id_containers = rootState.selected_chain.menu_ids;
        }

        const modes = {
          inside:
            (rootState.cafe.modes.inside || rootState.cafe.inside_lite) &&
            id_containers.inside &&
            id_containers.inside.includes(id),
        };

        if (rootState.cafe.preorder && rootState.cafe.preorder.menu_ids) {
          modes.preorder =
            rootState.cafe.modes.preorder &&
            id_containers.preorder.includes(id);
        }

        if (rootState.cafe.delivery) {
          modes.delivery =
            rootState.cafe.modes.delivery &&
            id_containers.delivery.includes(id);
        }

        if (rootState.cafe.hotels) {
          modes.hotels =
            rootState.cafe.modes.hotels && id_containers.hotels.includes(id);
        }

        if (rootState.cafe.preview) {
          modes.preview = id_containers.preview.includes(id);
        }

        return modes;
      };
    },
    isDeliveryMenu(state, getters, rootState) {
      return (id) => {
        if (!rootState.cafe.delivery || !rootState.cafe.delivery.menu_ids)
          return false;
        return rootState.cafe.delivery.menu_ids.includes(id);
      };
    },
    isPreorderMenu(state, getters, rootState) {
      return (id) => {
        if (!rootState.cafe.preorder || !rootState.cafe.preorder.menu_ids)
          return false;
        return rootState.cafe.preorder.menu_ids.includes(id);
      };
    },
    isDishObjectValid(state) {
      return (dish) => {
        if (!dish.name) return false;

        if (
          (dish.base_price === undefined || dish.base_price === null) &&
          !dish.price_groups.length
        )
          return false;

        const invalid_group = dish.price_groups.find((group) => {
          return !!group.items.find(
            (item) => !item.name || item.price === null
          );
        });

        return !invalid_group;
      };
    },
    isDishValid(state, getters) {
      if (!state.product) return false;

      return getters.isDishObjectValid(state.product);
    },
    isLocalizing(state) {
      return !!state.current_locale;
    },
    currentProductLocaleIndex(state, getters) {
      if (!getters.isLocalizing) return null;

      return state.product.i18n.findIndex(
        (item) => item.locale == state.current_locale
      );
    },

    currentProductLocale(state, getters) {
      if (!getters.isLocalizing) return null;

      return state.product.i18n[getters.currentProductLocaleIndex];
    },
  },
};
